import ArrowDownSVG from 'assets/icons/arrow-down-blue-icon.svg';
import ReferralContentTab1 from 'components/Profile/components/Referral/components/ReferralContentTab1';
import ReferralContentTab2 from 'components/Profile/components/Referral/components/ReferralContentTab2';
import { REFERRAL_CONTENT_TABS_LABEL } from 'constants';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import styled from 'styled-components';
import { domUtils } from 'utils';

const CustomQAAccordion = ({ paddingTop }) => {
  const { t } = useLang();

  const [current, setCurrent] = useState(0);

  const handleAccordionItemOnClick = (index) => {
    if (current === index) {
      setCurrent(-1);
      return;
    }
    setCurrent(index);
  };

  const referralContentReference = {
    0: <ReferralContentTab1 />,
    1: <ReferralContentTab2 />,
  };
  const renderAccordionItemBodyContent = (index) => {
    const isActive = current === index;
    if (isActive)
      return (
        <AccordionItemBodyContent $isActive={isActive}>
          <Divider />
          {referralContentReference[index]}
        </AccordionItemBodyContent>
      );
    return <AccordionItemBodyContent />;
  };

  return (
    <FieldWrap $paddingTop={paddingTop}>
      <AccordionStyled>
        {REFERRAL_CONTENT_TABS_LABEL.map((tab, index) => (
          <AccordionItem
            key={index}
            eventKey={index}
            onClick={() => handleAccordionItemOnClick(index)}
          >
            <AccordionHeader
              $height={
                domUtils.isReady &&
                document.getElementsByClassName(
                  `accordion-header-text-${index}`
                )?.[0]?.offsetHeight
              }
            >
              <AccordionHeaderText className={`accordion-header-text-${index}`}>
                {t(tab?.label)}
              </AccordionHeaderText>
              <AccordionHeaderBody>
                {renderAccordionItemBodyContent(index)}
              </AccordionHeaderBody>
            </AccordionHeader>
          </AccordionItem>
        ))}
      </AccordionStyled>
    </FieldWrap>
  );
};

const FieldWrap = styled.div`
  ${Fade};
  display: grid;
  width: 100%;
  height: fit-content;
  margin-top: ${(props) => props.$paddingTop}px;
  border-radius: 20px 20px 0 0;
  background-color: #f3f4f680;
`;

const AccordionStyled = styled(Accordion)`
  width: 100%;
  margin-top: 0px;
`;
const AccordionItem = styled(Accordion.Item)`
  border: none;
  background: transparent;
  border-radius: 0;
  margin-bottom: 0px;
  border-bottom: 1px solid #7a8189;
  width: calc(100% - 32px);
  margin-inline: 16px;

  &:last-child {
    border-radius: 0;
  }
`;
const AccordionHeader = styled(Accordion.Header)`
  height: fit-content;
  padding: 11px 16px;
  padding-inline: 0px;
  box-shadow: none !important;
  border-radius: 12px;

  & button {
    padding: 0;
    background-color: transparent !important;
    box-shadow: none !important;
    display: block;

    &:focus,
    &:hover {
      z-index: 1;
    }

    &::after,
    &:not(.collapsed)::after {
      background-image: url(${ArrowDownSVG});
      background-position: center;
      background-size: 10px 6px;
      position: absolute;
      top: ${(props) => `${props.$height ? (props.$height - 20) / 2 : 0}px`};
      right: 0px;
    }
  }
`;
const AccordionHeaderText = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);
  text-transform: uppercase;

  padding: 0;
  padding-right: 20px;
  margin: 0;
  min-height: 40px;
  display: flex;
  align-items: center;
`;

const AccordionHeaderBody = styled.div``;
const AccordionItemBodyContent = styled.div`
  padding-bottom: ${(props) => props.$isActive && '4px'};
`;

const Divider = styled.div`
  border-bottom: 1px solid transparent;
  margin: 8px 0;
`;

export default CustomQAAccordion;
